import { LoginCallback } from '../dna/types';

export const defaultLoginCallback: LoginCallback = (loginUri) => {
  window.location.replace(loginUri);
};
